module.exports = __webpack_public_path__ + "static/media/downloadIcon.de2cda7d.svg";